import { useQuery } from "@apollo/client";
import { TOP_5_CLIP } from "../../GraphQL/top5";

export const Top5WidgetViewModel = () => {
  const { data, loading } = useQuery(TOP_5_CLIP);

  return {
    loading,
    clip: data?.clipsNew?.nodes[0],
  };
};
